<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";

.btn.btn-clean.pagar:hover:not(.btn-text):not(:disabled):not(.disabled)
  .svg-icon
  svg
  g
  [fill],
.btn.btn-clean.pagar:focus:not(.btn-text) .svg-icon svg g [fill],
.btn.btn-clean.pagar.focus:not(.btn-text) .svg-icon svg g [fill] {
  fill: #f64e60 !important;
}

.btn.btn-clean.receber:hover:not(.btn-text):not(:disabled):not(.disabled)
  .svg-icon
  svg
  g
  [fill],
.btn.btn-clean.receber:focus:not(.btn-text) .svg-icon svg g [fill],
.btn.btn-clean.receber.focus:not(.btn-text) .svg-icon svg g [fill] {
  fill: #1bc5bd !important;
}

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/

@media print {
  #kt_aside {
    display: none !important;
  }

  #kt_header_mobile {
    display: none !important;
  }
  
  #kt_subheader {
    display: none !important;
  }

  #kt_footer {
    display: none !important;
  }

  #kt_scrolltop {
    display: none !important;
  }

  .invisible-print {
    display: none !important;
  }

  body {
    background-color: #fff !important;
  }
}
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";

export default {
  name: "MetronicVue",
  mounted() {
    let vm = this;

    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);

    window.addEventListener(
      "naoAutorizado",
      function() {
        vm.$router.push({ path: "/login" });
      },
      false
    );
  }
};
</script>
